import { frenchDaysOfWeek, weekDays } from '@gozoki/api-types'

/** Options d'un sélecteur de jour de la semaine, du lundi au dimanche, en libellés longs. */
export const WEEK_DAY_OPTIONS = weekDays.map((day) => ({
  value: day,
  label: frenchDaysOfWeek[day],
}))
